<template lang="pug">
div
  h4 Upload naar eigen FTP server
  p DealerFinanceServices zal de binnenkomende aanvragen als Maex XML uploaden naar de onderstaande FTP server.

  text-field.ftp-hostname.mr-0(
    label='Hostnaam',
    v-model='data.host',
    prefix='ftp://',
    placeholder='mijnwebsite.nl of IP adres',
    required,
    :error-messages='hostValidationErrors',
    @change='$v.data.host.$touch()',
    @blur='$v.data.host.$touch()'
    )

  v-layout.mt-2
    text-field(
      label='Gebruikersnaam',
      v-model='data.username',
      required,
      :error-messages='usernameValidationErrors',
      @change='$v.data.username.$touch()',
      @blur='$v.data.username.$touch()'
      )

    text-field.ml-4(
      label='Wachtwoord',
      v-model='data.password',
      type='password',
      :append-icon="passwordVisible ? 'fa fa-eye-slash' : 'fa fa-eye'"
      @click:append='passwordVisible = !passwordVisible',
      :type="passwordVisible ? 'text' : 'password'",
      required,
      :error-messages='passwordValidationErrors',
      @change='$v.data.password.$touch()',
      @blur='$v.data.password.$touch()'
      )
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  props: {
    value: Object
  },

  data () {
    return {
      data: Object.assign({}, this.value),
      passwordVisible: false
    }
  },

  computed: {
    hostValidationErrors () {
      const errors = []
      if (!this.$v.data.host.$dirty) return errors
      !this.$v.data.host.required && errors.push('Dit veld is verplicht')
      !this.$v.data.host.nopath && errors.push('Gebruik het volgende formaat, zonder extra pad: mijnwebsite.nl of 221.123.32.82')
      return errors
    },

    usernameValidationErrors () {
      const errors = []
      if (!this.$v.data.username.$dirty) return errors
      !this.$v.data.username.required && errors.push('Dit veld is verplicht')
      return errors
    },

    passwordValidationErrors () {
      const errors = []
      if (!this.$v.data.password.$dirty) return errors
      !this.$v.data.password.required && errors.push('Dit veld is verplicht')
      return errors
    }
  },

  watch: {
    data: {
      handler: function (v) {
        this.$emit('input', v)
      },
      deep: true
    },

    '$v.$invalid': {
      handler: function (v) {
        this.$emit('valid', !v)
      },
      immediate: true
    }
  },

  validations: {
    data: {
      host: {
        required,
        nopath: (v) => !v.includes('/')
      },

      username: {
        required
      },

      password: {
        required
      }
    }
  }
}
</script>

<style lang="scss">
.ftp-hostname .v-text-field__prefix {
  width: 45px;
}
</style>
